import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, ElementRef } from '@angular/core';

import { TokenService } from '../../../../shared/services/token/token.service';
import { VendaService } from '../../../../shared/services/venda/venda.service';

import * as moment from 'moment';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-checkout2',
  templateUrl: './checkout2.component.html',
  styleUrls: ['./checkout2.component.scss']
})
export class Checkout2Component implements OnInit {
  public token: any = null;
  public sales: any[] = [];
  public client: any = null;

  public saleId = '';
  public tokenId = '';

  public newCreditCardForm = false;

  public titles: string[] = ['Pagamento', 'Editar'];

  constructor(
    private title: Title,
    private router: Router,
    private elRef: ElementRef,
    private route: ActivatedRoute,
    private tokenService: TokenService,
    private vendaService: VendaService
  ) { }

  ngOnInit() {
    this.setTitle();
    this.getParams();
  }

  setTitle() {
    this.title.setTitle('Pague.lá | Checkout');
  }

  getParams() {
    this.route.queryParams.subscribe((data) => {
      // Invalid parameters
      if (JSON.stringify(data) === '{}' || (data && data.tokenId && data.vendaId) || (data && !data.tokenId && !data.vendaId)) {
        this.router.navigate(['checkout/404']);
        return;
      }

      // Go to token
      if (data && data.tokenId) {
        this.tokenId = data.tokenId;
        this.getToken();
        return;
      }

      // Go to sale edit
      if (data && data.vendaId) {
        this.saleId = data.vendaId;
        this.getSale();
        return;
      }
    });
  }

  getToken() {
    this.tokenService.obterToken(this.tokenId).subscribe((data: any) => {
      this.token = data;
      this.sales = data.Vendas;
      this.client = data.Cliente;
      this.newCreditCardForm = true;
    }, (err) => {
      console.error(err);
      this.router.navigate(['/checkout/404']);
    });
  }

  getSale() {
    this.vendaService.obterVenda(this.saleId).subscribe((data) => {
      this.sales = [];
      this.sales.push(data);
    }, (err) => {
      console.error(err);
    });
  }

  submit(e) {
    e.preventDefault();
    this.openModal();
  }

  openModal() {
    this.elRef.nativeElement.querySelector('.modal-checkout').classList.add('modal-checkout-show');
  }

  getFormatedDate(date) {
    return moment(date).format('DD/MM/YYYY');
  }

  isTodayDate(date) {
    return moment(date).format('DD/MM/YYYY') === moment().format('DD/MM/YYYY') ? true : false;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/checkout2/components/checkout2/checkout2.component.ts